import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "../../common/reduxQuery/helpers";
import { AdjacentDocumentSetIds } from "../../documentSet/interfaces/documentSet";

export const annotationSideControlsApi = createApi({
  reducerPath: "annotationSideControlsApi",
  baseQuery: customBaseQuery(),
  endpoints: (build) => ({
    sendEmailReply: build.mutation<
      void,
      {
        documentSetId: string;
        replyText: string;
      }
    >({
      query: (data) => ({
        url: `api/v1/mail/reply`,
        body: data,
        method: "POST",
      }),
    }),
    getAdjacentDocumentSetIds: build.query<
      AdjacentDocumentSetIds,
      {
        documentSetId: string;
        page: number;
        // `buildSorters` returns null when there is nothing to sort on.
        sort: string | null;
        filter: string;
      }
    >({
      query: ({ documentSetId, page, sort, filter }) => {
        const parsedSort = sort ? `&sort=${encodeURIComponent(sort)}` : "";

        return {
          url: `api/v1/document-sets/${documentSetId}/adjacent-ids?page=${page}${parsedSort}&filter=${encodeURIComponent(
            filter,
          )}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useSendEmailReplyMutation,
  useLazyGetAdjacentDocumentSetIdsQuery,
} = annotationSideControlsApi;
